/**
 * Shared 401 (Unauthorized) detector for errors surfaced by TanStack Query.
 *
 * Structural on purpose — it does NOT gate on `axios.isAxiosError`. These errors
 * originate inside `@sdx/b2o-fe-tools`; if that layer ever wraps or normalizes them,
 * an `isAxiosError`-gated check would stop recognizing the 401 and the caller would
 * misread a transient token-expiry as a genuine auth failure — which is exactly the
 * regression behind #820413 (forced logout to /login on an access-token expiry).
 *
 * The top-level `status` branch mirrors the shape some layers flatten to, and keeps
 * this predicate compatible with the checks it replaces in `retryPolicy`,
 * `useLoginPermissionCheck` and `AuthContext`.
 */
export const isUnauthorizedError = (error: unknown): boolean => {
  const candidate = error as { response?: { status?: number }; status?: number } | null | undefined;
  return candidate?.response?.status === 401 || candidate?.status === 401;
};
